const immat2Roues = {
  conversionRegex: /^([A-Z]{1,2})[\s-]*([0-9]{3})[\s-]*([A-Z])$/i,
  validationRegex: /^[A-Z]{1,2}-[0-9]{3}-[A-Z]$/,
  norme: '$1-$2-$3',
};
const immatNouveauFormat = {
  conversionRegex: /^([A-Z]{2})[\s-]*([0-9]{3})[\s-]*([A-Z]{2})$/i,
  validationRegex: /^[A-Z]{2}-[0-9]{3}-[A-Z]{2}$/,
  norme: '$1-$2-$3',
};
const immatAncienFormat = {
  conversionRegex: /^([0-9]{1,4})[\s-]*([A-Z]{1,3})[\s-]*([0-9]{2,3}|2A|2B)$/i,
  validationRegex: /^[0-9]{1,4}[A-Z]{1,3}([0-9]{2,3}|2A|2B)$/,
  norme: '$1$2$3',
};

const immatGetFormat = (immat: string) => {
  if (immat2Roues.conversionRegex.test(immat)) {
    return immat2Roues;
  }

  if (immatNouveauFormat.conversionRegex.test(immat)) {
    return immatNouveauFormat;
  }

  if (immatAncienFormat.conversionRegex.test(immat)) {
    return immatAncienFormat;
  }

  return null;
};

export default function (immat: string) {
  if (typeof immat !== 'string') {
    return immat;
  }

  const format = immatGetFormat(immat);

  if (format === null) {
    return immat;
  }

  return immat.replace(format.conversionRegex, format.norme).toUpperCase();
}
